export const environment = {
  production: true,
  APP_ID: '6da461ef-df96-42bc-9ef7-62d7143cb958',
  PROMO_CODE: 'IHG',
  API_BASE_URL: 'https://promo.united.com/offers/api/ihgstatus',
  ASSETS_BASE_URL: 'https://promo.united.com/assets/img/',
  IMAGE_BASE_URL: 'https://promo.united.com/ihgstatus/assets/'
};